<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.pesint_id+''" role="tab" data-toggle="tab" v-if="rowData.pessoa_interface_ftp.length>0">
						<span class="nav-link-in">
							FTP
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t2'+rowData.pesint_id+''" role="tab" data-toggle="tab" v-if="rowData.pessoa_interface_email.length>0">
                        <span class="nav-link-in">
                            Email
                            <i class="fa fa-bulding"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t3'+rowData.pesint_id+''" role="tab" data-toggle="tab" v-if="rowData.pessoa_interface_api.length>0">
                        <span class="nav-link-in">
                            API
                            <i class="fa fa-bulding"></i>
                        </span>
                    </a>
                </li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show"  v-bind:id="'t1'+rowData.pesint_id+''" v-if="rowData.pessoa_interface_ftp.length>0">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 20%">Folder</th>
                                    <th style="width: 20%">Folder Backup</th>
                                    <th style="width: 20%">Extensão</th>
                                    <th style="width: 20%">Conexão</th>
                                    <th style="width: 20%">Status</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.pessoa_interface_ftp">
                                    <td>
                                        {{ item.folder }}
                                    </td>
                                    <td>
                                        {{ item.folder_backup }}
                                    </td>
                                    <td>
                                        {{ item.extensao_arq }}
                                    </td>
                                    <td>
                                        {{ item.pessoa_conexao_ftp.descr }}
                                    </td>
                                    <td>
                                        <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"  v-bind:id="'t2'+rowData.pesint_id+''" v-if="rowData.pessoa_interface_email.length>0">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 33%">Extensão</th>
                                    <th style="width: 34%">Conexão</th>
                                    <th style="width: 33%">Status</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.pessoa_interface_email">
                                    <td>
                                        {{ item.extensao_arq }}
                                    </td>
                                    <td>
                                        {{ item.pessoa_conexao_email.host }}
                                    </td>
                                    <td>
                                        <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"  v-bind:id="'t3'+rowData.pesint_id+''" v-if="rowData.pessoa_interface_api.length>0">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 30%">Url endpoint</th>
                                    <th style="width: 40%">Método</th>
                                    <th style="width: 40%">Conexão</th>
                                    <th style="width: 30%">Status</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.pessoa_interface_api">
                                    <td>
                                        {{ item.url_endpoint }}
                                    </td>
                                    <td>
                                        {{ item.metodo }}
                                    </td>
                                    <td>
                                        {{ item.pessoa_conexao_api.cd }}
                                    </td>
                                    <td>
                                        <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
  }
}
  </script>
